import { IEas2, ILeagueContestants, IMatch, IInstantChallenger, IMatchMaker, IChallenge, IContestant } from "../../typings/typings";
import { Base } from "../config/contestant_state/Base";
import { League } from "./League";

export class Eas2 extends League implements IEas2 {
    public contestants: ILeagueContestants;
    public instantChallenger: IInstantChallenger;
    public matchmaker: IMatchMaker;
    public challenge: IChallenge;
    public state;

    public divisions;
    public season;
    public type;
    public upcomingMatchesStates;

    constructor(jsonData) {
        super(jsonData);

        this.contestants = jsonData.contestants;
        this.challenge = jsonData.challenge;
        this.state = jsonData.state;

        this.divisions = jsonData.divisions;
        this.season = jsonData.season;
        this.type = jsonData.type;
        this.upcomingMatchesStates = { open: 100, challenge: 100, protest: 0 };
        this.recentResultsCount = { closed: 6, protest: 0 }; // request 5+1 to check if we need to show the more results link
    }

    public setCurrentContestant(contestant: IContestant) {
        this.currentContestant = contestant;
        let base = new Base();
        /**
         *  In case a user left the eas and rejoined it later his contestant is still signed up, by setting him
         *  to not signed up he can sign up again.
         */
        if (this.currentContestant.state === "finished") {
            this.currentContestant.state = "not_signed_up";
        }

        if (contestant.state == base.CONTESTANT_STATE_SIGNED_UP) {
            this.currentContestant.state = base.CONTESTANT_STATE_NOT_SIGNED_UP;
        }
    }

    public getUrlByTemplate(template: string, $filter, $scope) {
        switch (template) {
            case "Header":
                return $filter("sprintf")($scope.templateUrls.templateHeaderUrl, this.type);
            case "Match":
                return $filter("sprintf")($scope.templateUrls.templateMatchUrl, this.type);
            case "Result":
                return $filter("sprintf")($scope.templateUrls.templateResultUrl, this.type);
            case "Information":
                return $filter("sprintf")($scope.templateUrls.templateInformationUrl, this.type);
            case "ChallengeType":
                return $filter("sprintf")($scope.templateUrls.templateChallengeTypesUrl, this.type);
            default:
                return super.getUrlByTemplate(template, $filter, $scope);
        }
    }

    public getNextDate(): Date {
        return null;
    }

    public getSecondsUntilNextUpdate(): number {
        return 0;
    }

    public hasCountDown(): boolean {
        return false;
    }

    public hasSeason(): boolean {
        return true;
    }

    /**
     * Checks whether league has a running season or not
     *
     * @returns {boolean}
     */
    public hasRunningSeason(): boolean {
        let now = new Date().getTime();
        let seasonBegin = new Date(this.season.begin).getTime();
        let seasonEnd = new Date(this.season.end).getTime();
        return now > seasonBegin && now < seasonEnd;
    }

    /**
     * Return the current league-state
     *
     * @return The league-state
     */
    public getState(): string {
        if (!this.hasRunningSeason()) {
            return "finished";
        } else if (this.isContestantNotSignedUp()) {
            return "signUp";
        } else {
            return "inProgress";
        }
    }

    public getCurrentMatch(matches): IMatch {
        if (matches.open.length > 0) {
            return matches.open[0];
        }
        if (matches.challenge.length > 0) {
            return matches.challenge[0];
        }
        return null;
    }
}
